
import ClickOutside from "vue-click-outside";
import { mapState } from "vuex";

export default {
  directives: { ClickOutside },

  props: {
    tiles: { type: Array, required: true },
    selectedItem: { type: String, required: true },
    variantLabel: { type: String, required: true },
    variants: { type: Array, required: true },
    isSingleSizeSelected: { type: Boolean, default: false },
    type: { type: String, required: true },
  },

  data: () => ({ infoDialog: false }),

  computed: {
    ...mapState({ mattressLabel: s => s.siteConfig.pdp.mattressFeelLabel }),
    labelForFeel() {
      return this.hasComfortFeel(this.variantLabel)
        ? this.variantLabel?.replace("Comfort", "Mattress")
        : "";
    },
    items() {
      return this.tiles.map(({ targetVariantId, tileLabel }) => ({
        itemId: targetVariantId,
        itemLabel: tileLabel,
      }));
    },
  },

  methods: {
    getvariantPrice(id) {
      const variant = this.variants?.find(variant => variant.id == id);
      return variant?.price || null;
    },
    hasComfortFeel(label) {
      return (
        [
          "Comfort Feel",
          "Comfort Feel Left",
          "Comfort Feel - Side One",
        ].includes(label) ||
        (!this.isSingleSizeSelected &&
          ["Comfort Feel Right", "Comfort Feel - Side Two"].includes(label))
      );
    },
  },
};
